module.exports = {
          srcSet: __webpack_public_path__ + "public/aa876e7cc706d61a8937422fed6935c1-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/aa876e7cc706d61a8937422fed6935c1-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/aa876e7cc706d61a8937422fed6935c1-80.png",
          toString:function(){return __webpack_public_path__ + "public/aa876e7cc706d61a8937422fed6935c1-80.png"},
          
          width: 80,
          height: 80
        }